module.exports = {
    Data: require('./data/collection'),
    General: require('./utils/general'),
    GraphCollection: require('./utils/graph/collection'),
    RequestCollection: require('./utils/request/collection'),
    Request: require('./utils/request/AllRequest')
}